import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { getDateAsObject } from "../../core/et3-date";
import { post } from "../axios-post";
import { TDataRow } from "../../Types";

export const apiCallGetAdminEventsStatistics = async ({
  adminId,
  dateMin,
  dateMax,
  type,
  limit
}: {
  adminId: number;
  dateMin: Date;
  dateMax: Date;
  type: string;
  limit: number;
}): Promise<{
  data: {
    eventsStatistics: {
      customDate: Date;
      total: number;
    }[];
    dailyStatistics: TDataRow[];
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const { status, data, et3Error } = await post<{
    adminEvents: {
      eventsStatistics: { customDate: Date; total: number }[];
      dailyStatistics: TDataRow[];
    };
  }>(`auditor/getEventsStatistics`, {
    adminId,
    dateMinObject: getDateAsObject(dateMin),
    dateMaxObject: getDateAsObject(dateMax),
    type,
    limit
  });

  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data: data.adminEvents,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        eventsStatistics: [
          {
            customDate: new Date(0),
            total: 0
          }
        ],
        dailyStatistics: []
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        eventsStatistics: [{ customDate: new Date(0), total: 0 }],
        dailyStatistics: []
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
